import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { UpdateVerificationFlowBody, VerificationFlow } from '@ory/client';
import { MessageModule } from 'primeng/message';
import { VKratosFormFieldDirective } from 'src/app/core/components/kratos-form/form-slot.directive';
import { KratosFormV2Component } from 'src/app/core/components/kratos-form/form.component';
import { SharedModule } from 'src/app/core/shared.module';
import { KratosAuthenticationService } from 'src/app/services/authentication/kratos.service';
import { LoadUserAction } from 'src/app/store/user/user.actions';
import { VCardComponent } from '../../../core/components/ui-kit/card/card.component';
import { VBottomGradientWrapperComponent } from '../components/bottom-gradient/bottom-gradient.component';
import { VLogoHeaderComponent } from '../components/logo-header/logo-header.component';

@Component({
  selector: 'app-verification',

  imports: [
    SharedModule,
    VCardComponent,
    MessageModule,
    ReactiveFormsModule,
    KratosFormV2Component,
    VKratosFormFieldDirective,
    VBottomGradientWrapperComponent,
    VLogoHeaderComponent,
  ],
  templateUrl: './verification.component.html',
})
export class VerificationPageComponent {
  private auth = inject(KratosAuthenticationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private store = inject(Store);

  private prefilledCode = '';

  verificationFlow = signal<VerificationFlow | undefined>(undefined);

  public isInitialFlowLoading = signal<boolean>(true);

  verificationFlowId?: string;

  constructor() {
    this.route.queryParams.subscribe(params => {
      this.verificationFlowId = params['flow'];

      this.loadVerificationFlow(this.verificationFlowId!);

      if (params['code']) {
        this.prefilledCode = params['code'];
      }
    });
  }

  async createVerificationFlow() {
    const flow = await this.auth.createVerificationFlow();
    this.verificationFlow.set(flow);
  }

  loadVerificationFlow(flowId: string) {
    this.auth
      .loadVerificationFlow(flowId)
      .then(flow => {
        const codeNode = flow?.ui.nodes.find(n => {
          return (
            n.attributes.node_type === 'input' && n.attributes.name === 'code'
          );
        });
        (codeNode?.attributes as any).value = this.prefilledCode;
        this.verificationFlow.set(flow);
      })
      .catch(() => {
        this.createVerificationFlow();
      })
      .finally(() => {
        this.isInitialFlowLoading.set(false);
      });
  }

  submitFlow(verificationFlow: UpdateVerificationFlowBody) {
    this.auth
      .updateVerificationFlow(this.verificationFlow()!.id!, verificationFlow)
      .then(flow => {
        this.verificationFlow.set(flow);

        if (flow.state === 'passed_challenge') {
          setTimeout(() => {
            this.store.dispatch(new LoadUserAction());
            this.router.navigate(['/']);
          }, 1500);
        }
      })
      .catch(err => {
        this.verificationFlow.set(err.response.data);
      });
  }
}
